import { useEffect, useState } from "react";
import ButtonComponent from "../../../components/common/button/Button";
import { MultiDropdown } from "../../../components/common/MultiDropdown";
import Modal from "../../../components/common/modal/Modal";
import './index.css';
import ActionInput from '../../../components/common/actioninput/ActionInputField';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { NewGroupedMultiDropdown } from "./NewGroupedMultiDropdown";
import { useDispatch, useSelector } from "react-redux";
import { getSupplierDropdownList } from "../../../redux/actions/SupplierDropdownListSlice";
import { getEmailDomainListEndpoint, getSupplierDropdownListEndpoint } from "../../../common/endpoints";
import { getEmailDomainSuppliersList } from "../../../redux/actions/GetEmailDomainSupplierListSlice";
import { GroupedSupplierDropdown } from "./GroupedSupplierDropdown";
import { Loader } from "../../../components/common/Loader";

const InviteUserModal = ({ openInviteUserModal, handleCloseInviteUserModal, handleSubmitInviteUserModal, isEditMode, editModeData, handleUpdateEditDetailsModal }) => {
    const dispatch = useDispatch();
    const [disableAddApprovalButton, setDisableAddApprovalButton] = useState(true);
    const [apiSupplierListData, setApiSupplierListData] = useState([]);
    const [displayRoleOptions, setDisplayRoleOptions] = useState([]);
    const SupplierDropdownListSlice = useSelector((state) => state.SupplierDropdownListSlice);
    const PostInviteSupplierListSlice = useSelector((state) => state.PostInviteSupplierListSlice);

    useEffect(() => {
        if (openInviteUserModal) {
            getSupplierList();
        }
    }, [openInviteUserModal])

    const getSupplierList = async () => {
        const loggedInUserEmail = localStorage.getItem("userEmail");
        try {
            const responseSupplierData = await dispatch(getSupplierDropdownList({
                dynamicEndpoint: getSupplierDropdownListEndpoint,
                params: {
                    userEmail: loggedInUserEmail
                }
            }));

            if (responseSupplierData?.meta?.requestStatus === 'fulfilled') {
                const list = responseSupplierData?.payload;
                const checkRole = list?.isGlobalSupplierAdmin;
                if (checkRole === true) {
                    setDisplayRoleOptions([
                        {
                            "id": 1,
                            "role": "Supplier Admin - Global",
                        },
                        {
                            "id": 2,
                            "role": "Supplier Admin - Local",
                        },
                        {
                            "id": 3,
                            "role": "Supplier Planner",
                        }])
                } else if (checkRole === false) {
                    setDisplayRoleOptions([
                        {
                            "id": 1,
                            "role": "Supplier Admin - Local",
                        },
                        {
                            "id": 2,
                            "role": "Supplier Planner",
                        }])
                }
                setApiSupplierListData(list);

            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const initialData = [
        {
            level: 1, supplierId: '', email: '', role: "",
            rowKey: `${Date.now()}_${Math.random().toString(36).slice(2)}`
        }
    ];
    const [rows, setRows] = useState(initialData);
    const [key, setKey] = useState(0);

    const showSupplierEditDetails = (data, supplierData, role, rowKeyEdit) => {
        const flattenedChildSuppliers = supplierData?.flatMap(parent =>
            parent.childSuppliers.map(child => ({
                parentId: parent.parentId,
                parentName: parent.parentName,
                supplierId: child.supplierId,
                supplierName: child.supplierName,
                plants: child.plants ?? [],
                rowKey: rowKeyEdit,
                type: "parent"
            }))
        );
        const apiData = apiSupplierListData ? apiSupplierListData?.parentChildSupplierDetailsList : [];

        const latestSupplierMapping = apiData?.filter(apiObj =>
            flattenedChildSuppliers.some(sm => sm.parentId === apiObj.parentId)
        );

        const latestFilterSuppliers = latestSupplierMapping?.flatMap(parent =>
            parent.childSuppliers.map(child => ({
                parentId: parent.parentId,
                parentName: parent.parentName,
                supplierId: child.supplierId,
                supplierName: child.supplierName,
                plants: child.plants ?? [],
                rowKey: rowKeyEdit,
                type: "parent"
            }))
        );
        const allPlants = flattenedChildSuppliers?.flatMap(item => item.plants);
        const result = Object.values(
            allPlants?.reduce((acc, item) => {
                if (!acc[item.plant]) {
                    acc[item.plant] = {
                        label: `${item.plant} | ${item.plantName}`,
                        title: `${item.plant} | ${item.plantName}`,
                        value: item.plant
                    };
                }
                return acc;
            }, {})
        );
        setRows(prev =>
            prev.map(row =>
                row.rowKey === rowKeyEdit
                    ? {
                        ...row,
                        level: 1,
                        supplierId: supplierData,
                        email: editModeData?.userEmail || "",
                        role: role,
                        rowKey: rowKeyEdit,
                        childSupplierId: flattenedChildSuppliers || [],
                        parentVendor: supplierData,
                        selectedSuppliers: flattenedChildSuppliers || [],
                        selectedPlants: result,
                        // plantOptions: allPlants,
                        filterSuppliers: latestFilterSuppliers || []
                    }
                    : row
            )
        );
    }

    useEffect(() => {
        if (isEditMode === true) {
            const rowKeyEdit = `${Date.now()}_${Math.random().toString(36).slice(2)}`;
            const updatedSupplierMapping = editModeData?.supplierMapping?.map(item => ({
                ...item,
                type: "parent",
                rowKey: rowKeyEdit
            }));
            const mapRole = (role, isGlobalSupplierAdmin) => {
                if (role === "Supplier Planner") return "Supplier Planner";
                if (role === "Supplier Admin" && isGlobalSupplierAdmin === true) return "Supplier Admin - Global";
                if (role === "Supplier Admin" && isGlobalSupplierAdmin === false) return "Supplier Admin - Local";
                return role.replace(/\s+/g, "");
            };
            const role = mapRole(editModeData?.role, editModeData?.isGlobalSupplierAdmin);
            setRows(prev => {
                const newRows = [...prev];
                newRows[0] = {
                    ...newRows[0],
                    level: 1,
                    supplierId: updatedSupplierMapping,
                    email: editModeData?.userEmail || "",
                    role: role,
                    rowKey: rowKeyEdit,
                }
                return newRows;
            })
            showSupplierEditDetails(editModeData, updatedSupplierMapping, role, rowKeyEdit)
        }
    }, [isEditMode])

    const handleAddUser = () => {
        const newLevel = rows.length + 1;
        setRows([...rows, {
            level: newLevel, supplierId: '', email: '', role: "",
            rowKey: `${Date.now()}_${Math.random().toString(36).slice(2)}`
        }]);
        setDisableAddApprovalButton(true);
    };

    const isFilledArray = (arr) => Array.isArray(arr) && arr.length > 0;
    const isRowValid = (row) => {
        const emailFilled = !!row.email?.trim();
        const roleFilled = !!row.role;

        const parentFilled = isFilledArray(row.supplierId);
        const childFilled = isFilledArray(row.childSupplierId);
        const plantFilled = isFilledArray(row.selectedPlants);

        if (!emailFilled || !roleFilled) return false;

        switch (row.role) {
            case "Supplier Planner":
                return parentFilled && childFilled && plantFilled;

            case "Supplier Admin - Global":
                return parentFilled;

            case "Supplier Admin - Local":
                return parentFilled && childFilled;

            // default:
            //     return false;
        }
    };
    const allNamesFilled = rows.length > 0 && rows.every(isRowValid);

    const handleDeleteRow = (index) => {
        const newRows = rows.filter((_, rowIndex) => rowIndex !== index);
        // Reassign levels
        const updatedRows = newRows.map((row, rowIndex) => ({
            ...row,
            level: rowIndex + 1
        }));
        setRows(updatedRows);
        // setKey(prevKey => prevKey + 1);
    };
    const handleChangeSupplierId = (index, name, value, rowKey) => {
        const newRows = [...rows];
        newRows[index]['filterSuppliers'] = [];
        newRows[index]['supplierId'] = value ? value : [];
        newRows[index]['selectedSuppliers'] = [];
        newRows[index]['childSupplierId'] = [];
        // newRows[index]['selectedPlants'] = [];
        // newRows[index]['plantOptions'] = [];

        const flattenedChildSuppliers = value?.flatMap(parent =>
            parent.childSuppliers.map(child => ({
                parentId: parent.parentId,
                parentName: parent.parentName,
                supplierId: child.supplierId,
                supplierName: child.supplierName,
                plants: child.plants ?? [],
                rowKey: rowKey,
                type: "parent"
            }))
        );
        newRows[index]['filterSuppliers'] = flattenedChildSuppliers ? flattenedChildSuppliers : [];

        if (newRows[index]['role'] === "Supplier Admin - Global") {
            // const allPlants = flattenedChildSuppliers?.flatMap(item => item.plants);
            // // newRows[index]['plantOptions'] = allPlants;
            // const result = Object.values(
            //     allPlants?.reduce((acc, item) => {
            //         if (!acc[item.plant]) {
            //             acc[item.plant] = {
            //                 label: `${item.plant} | ${item.plantName}`,
            //                 title: `${item.plant} | ${item.plantName}`,
            //                 value: item.plant
            //             };
            //         }
            //         return acc;
            //     }, {})
            // );
            setRows(prev =>
                prev.map(row =>
                    row.rowKey === rowKey
                        ? {
                            ...row,
                            childSupplierId: flattenedChildSuppliers ? flattenedChildSuppliers : [],
                            selectedSuppliers: flattenedChildSuppliers ? flattenedChildSuppliers : [],
                            // selectedPlants: result,
                            // plantOptions: allPlants,
                            filterSuppliers: flattenedChildSuppliers ? flattenedChildSuppliers : []
                        }
                        : row
                )
            );
        } else {
            setRows(newRows);
        }
        setDisableAddApprovalButton(false)
    };
    const handleChangePlants = (index, name, value) => {
        const allPlants = value.flatMap(item => item.plants);
        const newRows = [...rows];
        // newRows[index]['plantOptions'] = allPlants;
        newRows[index]['childSupplierId'] = value ? value : [];
        // newRows[index]['selectedPlants'] = [];

        setRows(newRows);
        setDisableAddApprovalButton(false);
    }
    const getUniqueValues = (data = []) => {
        if (data?.length > 0) {
            const unique = [];
            const map = new Set();

            data.forEach(p => {
                if (!map.has(p.plant)) {
                    map.add(p.plant);
                    unique.push(p);
                }
            });
            return unique?.map(value => ({ label: `${value.plant} | ${value.plantName}`, value: value.plant, title: `${value.plant} | ${value.plantName}` }))
        }
        else {
            return []
        }
    };

    const handleChangePlantsNew = (index, value) => {
        const newRows = [...rows];
        newRows[index]['selectedPlants'] = value ? value : [];
        setRows(newRows);
        setDisableAddApprovalButton(false);
    }

    const handleChangeRole = (index, event, value, rowKey) => {
        const newRows = [...rows];
        newRows[index]['role'] = value ? value.role : '';
        const allPlants = apiSupplierListData?.allPlants;

        const result = allPlants?.map(({ plant, plantName }) => ({
            label: `${plant} | ${plantName}`,
            title: `${plant} | ${plantName}`,
            value: plant
        }));

        if (value?.role === "Supplier Admin - Global") {
            const supplierArray = Array.isArray(newRows[index]?.supplierId)
                ? newRows[index].supplierId
                : [];
            const flattenedChildSuppliers = supplierArray?.flatMap(parent =>
                parent.childSuppliers.map(child => ({
                    parentId: parent.parentId,
                    parentName: parent.parentName,
                    supplierId: child.supplierId,
                    supplierName: child.supplierName,
                    plants: child.plants ?? [],
                    rowKey: parent.rowKey,
                    type: "parent"
                }))
            );

            newRows[index]['plantOptions'] = result;
            newRows[index]['selectedPlants'] = result;

            setRows(prev =>
                prev.map(row =>
                    row.rowKey === rowKey
                        ? {
                            ...row,
                            childSupplierId: flattenedChildSuppliers ? flattenedChildSuppliers : [],
                            selectedSuppliers: flattenedChildSuppliers ? flattenedChildSuppliers : [],
                            selectedPlants: result,
                            plantOptions: result,
                            filterSuppliers: flattenedChildSuppliers ? flattenedChildSuppliers : []
                        }
                        : row
                )
            );
        }
        else if (value?.role === "Supplier Admin - Local") {
            newRows[index]['plantOptions'] = result;
            newRows[index]['selectedPlants'] = result;
            setRows(prev =>
                prev.map(row =>
                    row.rowKey === rowKey
                        ? {
                            ...row,
                            selectedPlants: result,
                            plantOptions: result,
                        }
                        : row
                )
            );
        }
        else {
            setRows(newRows);
        }
        // setRows(newRows);
        setDisableAddApprovalButton(false)
    };
    const handleEmailBlur = async (value, rowKey) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value && emailRegex.test(value)) {
            try {
                const responseEmailDomainSupplierData = await dispatch(getEmailDomainSuppliersList({
                    dynamicEndpoint: getEmailDomainListEndpoint,
                    params: {
                        email: value
                    }
                }));
                if (responseEmailDomainSupplierData?.meta?.requestStatus === 'fulfilled') {
                    const res = responseEmailDomainSupplierData?.payload;
                    const data = apiSupplierListData ? apiSupplierListData?.parentChildSupplierDetailsList : [];
                    const parentChildFilteredData = data?.filter(apiItem =>
                        res.some(myItem => myItem.parentId === apiItem.parentId)
                    );

                    if (parentChildFilteredData && parentChildFilteredData?.length > 0) {
                        const mapped = parentChildFilteredData?.map(p => ({
                            type: "parent",
                            parentId: p.parentId,
                            parentName: p.parentName,
                            childSuppliers: p.childSuppliers,
                            rowKey
                        }));

                        const flattenedChildSuppliers = parentChildFilteredData?.flatMap(parent =>
                            parent?.childSuppliers?.map(child => ({
                                parentId: parent.parentId,
                                parentName: parent.parentName,
                                supplierId: child.supplierId,
                                supplierName: child.supplierName,
                                plants: child.plants ?? [],
                                rowKey: parent.rowKey,
                                type: "parent"
                            }))
                        );

                        setRows(prev =>
                            prev.map(row =>
                                row.rowKey === rowKey
                                    ? {
                                        ...row,
                                        supplierId: mapped,
                                        parentVendor: mapped,
                                        childSupplierId: flattenedChildSuppliers,
                                        selectedSuppliers: flattenedChildSuppliers,
                                        // selectedPlants: [],
                                        // plantOptions: [],
                                        filterSuppliers: flattenedChildSuppliers
                                    }
                                    : row
                            )
                        );
                    }
                }
            } catch (error) {
                console.error('API error:', error);
            }
        }
        else {
            console.error("Invalid email")
        }
    }
    const handleChangeEmail = (index, event) => {
        const newRows = [...rows];
        newRows[index]['email'] = event.target.value || '';
        setRows(newRows);
        setDisableAddApprovalButton(false)
    };
    const handleClearAll = () => {
        setRows(initialData);
        setKey(prevKey => prevKey + 1);
    };
    const onCloseInviteSupplierModal = () => {
        handleCloseInviteUserModal();
        handleClearAll();
    }
    const onClickCancel = () => {
        handleClearAll();
        handleCloseInviteUserModal();
    }
    const onClickSubmit = () => {
        handleSubmitInviteUserModal(rows);
    }
    const onClickUpdateDetails = () => {
        handleUpdateEditDetailsModal(rows);
    }

    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

    const isValidEmail = (email) => EMAIL_REGEX.test(email);

    const handlePasteEmailsFromClipboard = async () => {
        try {
            const clipboardText = await navigator.clipboard.readText();
            if (!clipboardText) return;

            const emails = clipboardText
                .split(/[\n,]+/)
                .map(e => e.trim())
                .filter(Boolean);

            if (!emails.length) return;

            // 🔥 Take row-2 as template (latest row)
            const templateRow = rows[rows.length - 1];

            const newRows = emails.map((email, index) => {
                const newRowKey = `${Date.now()}_${Math.random().toString(36).slice(2)}`;

                return {
                    ...templateRow,               // copy role, suppliers, plants, etc
                    level: rows.length + index + 1,
                    email,
                    rowKey: newRowKey,

                    // ✅ VERY IMPORTANT: reassign rowKey inside nested arrays
                    supplierId: templateRow?.supplierId?.map(p => ({
                        ...p,
                        rowKey: newRowKey,
                        type: "parent"

                    })),

                    childSupplierId: templateRow?.childSupplierId?.map(c => ({
                        ...c,
                        rowKey: newRowKey,
                        type: "parent"
                    })),

                    selectedSuppliers: templateRow?.childSupplierId?.map(c => ({
                        ...c,
                        rowKey: newRowKey,
                        type: "parent"
                    })),

                    filterSuppliers: templateRow?.filterSuppliers?.map(c => ({
                        ...c,
                        rowKey: newRowKey
                    })),

                    selectedPlants: templateRow?.selectedPlants || [],
                    plantOptions: templateRow?.plantOptions || []
                };
            });

            setRows(prev => {
                const merged = [...prev, ...newRows];

                const seen = new Set();

                const cleaned = merged.filter(row => {
                    const email = row?.email?.trim()?.toLowerCase();

                    // ❌ remove invalid
                    if (!isValidEmail(email)) return false;

                    // ❌ remove duplicates
                    if (seen.has(email)) return false;

                    seen.add(email);
                    return true;
                });

                // re-level rows
                return cleaned.map((row, idx) => ({
                    ...row,
                    level: idx + 1
                }));
            });
        } catch (err) {
            console.error("Failed to read clipboard", err);
        }
    };


    return (
        <div>
            <Modal
                className="InviteUserModal_cls"
                open={openInviteUserModal}
                handleClose={onCloseInviteSupplierModal}
                title={isEditMode === false && openInviteUserModal ? "Invite User" : isEditMode === true && openInviteUserModal ? "Edit User" : ""}
                fullWidth={true}
                maxWidth={"lg"}
                action={
                    <InviteUserModalFooter
                        onClickCancel={onClickCancel}
                        onClickSubmit={onClickSubmit}
                        handleClearAll={handleClearAll}
                        allNamesFilled={allNamesFilled}
                        openInviteUserModal={openInviteUserModal}
                        isEditMode={isEditMode}
                        onClickUpdateDetails={onClickUpdateDetails}
                        SupplierDropdownListSlice={SupplierDropdownListSlice}
                        PostInviteSupplierListSlice={PostInviteSupplierListSlice}
                    />
                }
                content={
                    <InviteUserModalContent
                        key={key}
                        disableAddApprovalButton={disableAddApprovalButton}
                        handleAddUser={handleAddUser}
                        handleChangeSupplierId={handleChangeSupplierId}
                        handleChangePlants={handleChangePlants}
                        handleChangePlantsNew={handleChangePlantsNew}
                        getUniqueValues={getUniqueValues}
                        handleChangeRole={handleChangeRole}
                        handleChangeEmail={handleChangeEmail}
                        userRoles={displayRoleOptions}
                        rows={rows}
                        allNamesFilled={allNamesFilled}
                        onHandleDeleteIcon={handleDeleteRow}
                        apiSupplierListData={apiSupplierListData}
                        handleEmailBlur={handleEmailBlur}
                        isEditMode={isEditMode}
                        openInviteUserModal={openInviteUserModal}
                        editModeData={editModeData}
                        SupplierDropdownListSlice={SupplierDropdownListSlice}
                        PostInviteSupplierListSlice={PostInviteSupplierListSlice}
                        handlePasteEmailsFromClipboard={handlePasteEmailsFromClipboard}
                    />
                }
            />
        </div>
    )
}
const InviteUserModalFooter = ({ onClickCancel, onClickSubmit, handleClearAll, allNamesFilled, openInviteUserModal, isEditMode, onClickUpdateDetails, SupplierDropdownListSlice, PostInviteSupplierListSlice }) => {
    return (
        <div className='btn-wrapper_inviteUser' style={{ display: 'flex', gap: 10 }}>
            <ButtonComponent
                label="Back"
                type="primary"
                maxWidth="80px"
                onClick={onClickCancel}
            />
            <ButtonComponent
                maxWidth="170px"
                label={"Clear All"}
                type="primary"
                onClick={handleClearAll}
            />
            {(isEditMode === true && openInviteUserModal) ?
                <ButtonComponent
                    label="Update"
                    type="secondary"
                    maxWidth="100px"
                    onClick={onClickUpdateDetails}
                    disabled={!allNamesFilled || SupplierDropdownListSlice.loading || PostInviteSupplierListSlice.loading}
                />
                : <ButtonComponent
                    label="Submit"
                    type="secondary"
                    maxWidth="100px"
                    onClick={onClickSubmit}
                    disabled={!allNamesFilled || SupplierDropdownListSlice.loading || PostInviteSupplierListSlice.loading}
                />}
        </div>
    );
};
const InviteUserModalContent = ({ key, userRoles, allNamesFilled, rows, handleChangeSupplierId, handleChangePlants, handleChangePlantsNew, getUniqueValues, handleChangeRole, handleChangeEmail, handleEmailBlur, handleAddUser, onHandleDeleteIcon, apiSupplierListData, isEditMode, openInviteUserModal, SupplierDropdownListSlice, PostInviteSupplierListSlice, handlePasteEmailsFromClipboard }) => {

    const apiResponse = apiSupplierListData ? apiSupplierListData?.parentChildSupplierDetailsList : [];
    const plantsDropdownOptions = apiSupplierListData ? apiSupplierListData?.allPlants : [];
    const loggedInUserRole = localStorage.getItem("userRole");

    return (
        SupplierDropdownListSlice.loading ?
            <Loader />
            :
            <div>
                {PostInviteSupplierListSlice.loading && <Loader />}
                <div className='approval-wrapper'>
                    {rows?.map((item, index) => (
                        <div className='sendForApprover-container' key={item.rowKey}>
                            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>

                                <div style={{ width: 50 }}>
                                    {index === 0 && <div style={{ marginBottom: 5, fontWeight: 'bold' }}>S.No</div>}
                                    <div style={{ height: 40, display: 'flex', alignItems: 'center' }}>{index + 1}</div>
                                </div>
                                <div style={{ flex: 1 }}>
                                    {index === 0 && <div style={{ marginBottom: 5, fontWeight: 'bold' }}>Email</div>}
                                    <ActionInput
                                        disabled={isEditMode}
                                        value={item.email}
                                        props={{ height: "40px", maxWidth: "202px", }}
                                        placeholder='Enter Email'
                                        label="Email"
                                        onBlur={(e) => loggedInUserRole === "App Admin" && handleEmailBlur(e.target.value, item.rowKey)}
                                        onChange={(event, value) => handleChangeEmail(index, event, value)}
                                    />
                                </div>

                                <div style={{ flex: 1 }}>
                                    {index === 0 && <div style={{ marginBottom: 5, fontWeight: 'bold' }}>Role</div>}
                                    <Autocomplete
                                        key={key}
                                        className="custom-autocomplete"
                                        freeSolo
                                        options={userRoles}
                                        getOptionLabel={(option) => option.role}
                                        renderInput={(params) => <TextField {...params}
                                            // label="Search"
                                            InputLabelProps={{ shrink: false }}
                                            placeholder='Select Role'

                                        />}
                                        onChange={(event, value) => handleChangeRole(index, event, value, item.rowKey)}
                                        style={{ height: 40, maxWidth: 200 }}
                                        value={userRoles.find(obj => obj.role === item.role) || null}
                                    />
                                </div>

                                {/* </div>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <div style={{ width: 40 }}></div> */}
                                <div style={{ flex: 1 }}>
                                    {index === 0 && <div style={{ marginBottom: 5, fontWeight: 'bold' }}>Parent Vendor</div>}
                                    <NewGroupedMultiDropdown
                                        rowKey={item.rowKey}
                                        id={item.rowKey}
                                        name={item.rowKey}
                                        options={apiResponse}
                                        // name="suppliers"
                                        label="Suppliers"
                                        selectedItemsData={item?.supplierId}
                                        onChangeItems={(name, items) => handleChangeSupplierId(index, name, items, item.rowKey)}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    {index === 0 && <div style={{ marginBottom: 5, fontWeight: 'bold' }}>Child Vendor</div>}
                                    <GroupedSupplierDropdown
                                        rowKey={item.rowKey}
                                        key={item.rowKey}
                                        options={item.filterSuppliers}
                                        name={"vendor"}
                                        label="vendor"
                                        selectedItemsData={item.selectedSuppliers}
                                        disabled={item.role === "Supplier Admin - Global"}
                                        onChangeItems={(name, items) => handleChangePlants(index, name, items)}
                                    />
                                </div>
                                <div style={{ flex: 1, alignItems: 'center' }}>
                                    {index === 0 && <div style={{ fontWeight: 'bold' }}>Plant</div>}
                                    <div className={`inviteUserMultiDropdown ${index === 0 ? "firstRowPlant" : "otherRowPlant"}`}>
                                        <MultiDropdown
                                            id={item.rowKey}
                                            name="vendorPlant"
                                            options={getUniqueValues(plantsDropdownOptions) || []}
                                            selectedItemsData={item?.selectedPlants || []}
                                            disabled={item.role === "Supplier Admin - Global" || item.role === "Supplier Admin - Local"}
                                            onChangeItems={(name, items) => handleChangePlantsNew(index, items)}
                                            height={40}
                                            copyPasteDisabled={false}
                                            ListboxComponentProps={false}
                                        />
                                    </div>
                                </div>
                                {!isEditMode && <div className='deleteIcon-column' style={{ textAlign: "right" }}>
                                    {index === 0 && <div style={{ marginBottom: 5, fontWeight: 'bold' }}><p></p></div>}
                                    <IconButton style={{ marginTop: index === 0 ? 10 : 0, }}>
                                        {rows.length !== 1 && <DeleteIcon onClick={() => onHandleDeleteIcon(index)} />}
                                    </IconButton>
                                </div>}
                            </div>
                        </div>
                    ))}
                    {isEditMode === false && openInviteUserModal && <div style={{ fontSize: 13, marginLeft: 70, marginBottom: 10 }} >
                        <span style={{ cursor: 'pointer', color: '#6ac9ce', fontSize: 14, }} onClick={handlePasteEmailsFromClipboard}>Paste Emails from Clipboard</span><span style={{ fontSize: 13, }}>{` (Duplicate/Invalid email id's not allowed)`}</span>
                    </div>}
                </div>
                {isEditMode === false && openInviteUserModal && <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '40px', marginTop: "15px" }}>
                    <ButtonComponent
                        maxWidth="170px"
                        label="Add User"
                        type="primary"
                        disabled={!allNamesFilled}
                        onClick={handleAddUser}
                    />
                </div>}
            </div>
    );
};

export default InviteUserModal;